// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .nav-tabs{
    display: block;
    width: 100%;
  }
  .nav-tabs li{
   display: inline-block;
  }
  .nav-tabs .nav-link{
    border: none;
    color: #000;
  }
  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{
    color: #E03546;
    font-weight: 600;
  }
  
  .form-check-input{
    width: 1.3rem;
    height: 1.3rem;
  }
  
  .mcs-horizontal-example{
    overflow-x: auto;
    white-space: nowrap;
  }
  
  .mcs-horizontal-example .item{
    display: inline-block;
  }
  .mCSB_horizontal.mCSB_inside>.mCSB_container {
      margin-right: 0;
      margin-bottom: 10px;
  }
  ul.shopbycategoryList li a{
    display: block;
      width: 112px;
      height: 130px;
      padding: 15px;
      background-color: #efefef;
      box-shadow: 0 1px 4px rgba(28, 28, 28, .06);
      border-radius: 12px;
      margin-right: 5px;
      margin-top: 5px;
  }
  ul.shopbycategoryList li a .categoryTitle{
    font-size: 13px;
  }
  ul.shopbycategoryList li a .categoryIcon{
    height: 60px;
  }
  .tab-content{
    padding-top: 30px;
    padding-bottom: 30px;
  } */
  
  .border-radius-imp{
    border-bottom-left-radius: 24px !important;
    border-bottom-right-radius: 24px !important;
  }
  .cart-accordian-btn {
    color: #000;
    background: #fff;
    font-weight: 600;
    border-radius: 24px !important;
    border-bottom: #e6e9ef !important;
    padding: 1.2rem !important;
  }

  .cart-accordian-item {
    border-radius: 24px !important;
  }

  .cart-accordian-btn:not(.collapsed) {
    color: #000;
    background-color: #FFF;
    box-shadow: inset 0 -1px 0 rgb(61 61 61 / 10%);
    border-bottom-right-radius: 24px !important;
    border-bottom-left-radius: 24px !important;
    border-bottom: #e6e9ef !important;
  }

  .cart-accordian-btn-first::after{
    display: none;
  }
  .accordion-button:not(.collapsed)::after {
    filter: grayscale(100%);
  }
  .step-counter{
    display: inline-block;
    padding: 8px;
    background: #ef4f5f;
    color: #FFF;
    border-radius: 12px;
    width: 32px;
    height: 32px;
    text-align: center;
    line-height: 18px;
    font-weight: 400;
    margin-right: 15px;
  }
  .address-type{
    background: #f4eded;
    padding: 4px 8px;
    border-radius: 6px;
    font-weight: 400;
  }
  .payment-accordian-btn {
    color: #000;
    background: #fff;
    font-weight: 600;
    border-radius: 6px !important;
    border:1px solid #D9D9D9 !important;
    padding: 1.2rem !important;
  }

  .payment-accordian-item {
    border-radius: 24px !important;
  }

  .payment-accordian-btn:not(.collapsed) {
    color: #000;
    background-color: #FFF;
    box-shadow: inset 0 -1px 0 rgb(61 61 61 / 10%);
    border-bottom-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
    border-bottom: #636363 !important;
  }
  .payment-accordian-item .accordion-collapse{
    border: 1px solid #D9D9D9;
    border-top: none;
  }
  ul.catitemList li{
    margin-bottom: 5px;
    border-bottom: none !important;
  }
  
  .whats-app {
    position: fixed !important;
    width: 50px !important;
    height: 50px !important;
    bottom: 40px !important;
    right: 20px !important;
    background-color: #25d366 !important;
    color: #FFF !important;
    border-radius: 50px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 30px !important;
    box-shadow: 2px 2px 3px #999 !important;
    z-index: 100 !important;
} 

.up-arrow {
  position: fixed !important;
  width: 45px !important;
  height: 45px !important;
  bottom: 100px !important;
  right: 23px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 100 !important;
}

.my-float {
    margin: 0 !important;
}
/* .accordion-item {
    background-color: #fff;
    border: none;
    box-shadow: 0 4px 16px 0 rgba(39, 49, 68, .04);
    margin-bottom: 24px;
    border-radius: 4px !important;
    border: 1px solid #cfcfcf !important;
}
.accordion-button:not(.collapsed) {
    color: #000;
    background-color: #FFF;
    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
} */

.search-results {
  position: absolute;
  background-color: white;
  width: 100%;
  max-height: 500px; /* Increased max height to allow more items */
  overflow-y: auto; /* Make it scrollable */
  border: 1px solid #ccc; /* Optional: Add a border */
  z-index: 1000; /* Ensure it appears above other elements */
  border-radius: 10px;
  padding: 10px; /* Add some padding for better appearance */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add a shadow for better visual separation */
}

/* Custom scrollbar styles */
.search-results::-webkit-scrollbar {
  width: 12px; /* Increase the width of the scrollbar */
}

.search-results::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background of the scrollbar track */
  border-radius: 45px;
}

.search-results::-webkit-scrollbar-thumb {
  background: #888; /* Color of the scrollbar thumb */
  border-radius: 10px;
}

.search-results::-webkit-scrollbar-thumb:hover {
  background: #555; /* Color of the scrollbar thumb when hovered */
}

.search-item {
  padding: 10px;
  border-bottom: 1px solid #ccc; /* Optional: Add a bottom border to each item */
}

.search-item:last-child {
  border-bottom: none; /* Remove border for the last item */
}

.search-item-content {
  display: flex;
  align-items: center;
}

.search-item-content img {
  margin-right: 10px; /* Space between image and text */
}

.icon-flag img {
  vertical-align: middle;
}
.btn-rounded13 {
  padding: 5px 10px;
  white-space: nowrap;
  width: auto;
  border-radius: 12px !important;
}

.app-logo {
  height: 34.3833px;
  object-fit: cover;
}

.box-with-plus {
  border: 3px solid rgb(196, 192, 192);
  width: 100px;
  height: 110px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

@media (max-width: 768px) {
    .d-flex {
      flex-wrap: wrap;
    }

    .loading-spinner {
    margin-top: 155px;
    height: 200px; /* Adjust based on design */
  }
}

@media (max-width: 480px) {
  .loading-spinner {
    margin-top: 130px; /* Adjust for smaller screens */
    height: 150px; /* Further adjustments */
  }
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 72px;
}

/* OTP Container */
.otp-container {
  display: flex;
  justify-content: center;
  gap: 10px;
}

/* OTP Input Fields */
.otp-input {
  width: 45px;
  height: 45px;
  font-size: 1.5rem;
  text-align: center;
  border: 2px solid #ccc;
  border-radius: 8px;
  transition: border-color 0.3s ease-in-out;
}

.otp-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  outline: none;
}

/* Media Query for Mobile Devices */
@media (max-width: 576px) {
  .otp-container {
    gap: 5px;
  }

  .otp-input {
    width: 35px;
    height: 35px;
    font-size: 1.2rem;
  }
}

.marquee-container {
  overflow: hidden;
}

.marquee-container-overdue {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  background-color: #fff3f3;
  padding: 10px 0;
  margin-top: 95px !important;
  position: sticky !important;
  top: 95px !important;
  z-index: 100;
}

.marquee-container-overdue-mobile {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  background-color: #fff3f3;
  padding: 10px 0;
  margin-top: 80px !important;
  position: sticky !important;
  top: 80px !important;
  z-index: 100;
}

.marquee-container {
  margin-top: 80px !important;
  position: sticky !important;
  top: 80px !important;
  z-index: 100;
}

.marquee {
  display: inline-block;
  white-space: nowrap;
  animation: marquee 15s linear infinite;
}

@keyframes marquee {
  0%   { transform: translateX(100%); }
  100% { transform: translateX(-100%); }
}

/* Media Query for Tablets */
@media (max-width: 768px) {
  .otp-input {
    width: 40px;
    height: 40px;
    font-size: 1.3rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAqDK;;EAEH;IACE,0CAA0C;IAC1C,2CAA2C;EAC7C;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,8BAA8B;IAC9B,iCAAiC;IACjC,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,8CAA8C;IAC9C,2CAA2C;IAC3C,0CAA0C;IAC1C,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,mCAAmC;IACnC,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,8CAA8C;IAC9C,0CAA0C;IAC1C,yCAAyC;IACzC,iCAAiC;EACnC;EACA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,oCAAoC;IACpC,sBAAsB;IACtB,8BAA8B;IAC9B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,0BAA0B;IAC1B,uCAAuC;IACvC,uBAAuB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;IACI,oBAAoB;AACxB;AACA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,iBAAiB,EAAE,6CAA6C;EAChE,gBAAgB,EAAE,uBAAuB;EACzC,sBAAsB,EAAE,2BAA2B;EACnD,aAAa,EAAE,2CAA2C;EAC1D,mBAAmB;EACnB,aAAa,EAAE,2CAA2C;EAC1D,wCAAwC,EAAE,8CAA8C;AAC1F;;AAEA,4BAA4B;AAC5B;EACE,WAAW,EAAE,wCAAwC;AACvD;;AAEA;EACE,mBAAmB,EAAE,sCAAsC;EAC3D,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,EAAE,iCAAiC;EACnD,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,EAAE,8CAA8C;AAClE;;AAEA;EACE,aAAa;EACb,6BAA6B,EAAE,+CAA+C;AAChF;;AAEA;EACE,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,EAAE,iCAAiC;AACvD;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;IACI;MACE,eAAe;IACjB;;IAEA;IACA,iBAAiB;IACjB,aAAa,EAAE,2BAA2B;EAC5C;AACF;;AAEA;EACE;IACE,iBAAiB,EAAE,+BAA+B;IAClD,aAAa,EAAE,wBAAwB;EACzC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;AACf;;AAEA,mCAAmC;AACnC;EACE;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,4BAA4B;AAC5B;EACE;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":["/* .nav-tabs{\n    display: block;\n    width: 100%;\n  }\n  .nav-tabs li{\n   display: inline-block;\n  }\n  .nav-tabs .nav-link{\n    border: none;\n    color: #000;\n  }\n  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{\n    color: #E03546;\n    font-weight: 600;\n  }\n  \n  .form-check-input{\n    width: 1.3rem;\n    height: 1.3rem;\n  }\n  \n  .mcs-horizontal-example{\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n  \n  .mcs-horizontal-example .item{\n    display: inline-block;\n  }\n  .mCSB_horizontal.mCSB_inside>.mCSB_container {\n      margin-right: 0;\n      margin-bottom: 10px;\n  }\n  ul.shopbycategoryList li a{\n    display: block;\n      width: 112px;\n      height: 130px;\n      padding: 15px;\n      background-color: #efefef;\n      box-shadow: 0 1px 4px rgba(28, 28, 28, .06);\n      border-radius: 12px;\n      margin-right: 5px;\n      margin-top: 5px;\n  }\n  ul.shopbycategoryList li a .categoryTitle{\n    font-size: 13px;\n  }\n  ul.shopbycategoryList li a .categoryIcon{\n    height: 60px;\n  }\n  .tab-content{\n    padding-top: 30px;\n    padding-bottom: 30px;\n  } */\n  \n  .border-radius-imp{\n    border-bottom-left-radius: 24px !important;\n    border-bottom-right-radius: 24px !important;\n  }\n  .cart-accordian-btn {\n    color: #000;\n    background: #fff;\n    font-weight: 600;\n    border-radius: 24px !important;\n    border-bottom: #e6e9ef !important;\n    padding: 1.2rem !important;\n  }\n\n  .cart-accordian-item {\n    border-radius: 24px !important;\n  }\n\n  .cart-accordian-btn:not(.collapsed) {\n    color: #000;\n    background-color: #FFF;\n    box-shadow: inset 0 -1px 0 rgb(61 61 61 / 10%);\n    border-bottom-right-radius: 24px !important;\n    border-bottom-left-radius: 24px !important;\n    border-bottom: #e6e9ef !important;\n  }\n\n  .cart-accordian-btn-first::after{\n    display: none;\n  }\n  .accordion-button:not(.collapsed)::after {\n    filter: grayscale(100%);\n  }\n  .step-counter{\n    display: inline-block;\n    padding: 8px;\n    background: #ef4f5f;\n    color: #FFF;\n    border-radius: 12px;\n    width: 32px;\n    height: 32px;\n    text-align: center;\n    line-height: 18px;\n    font-weight: 400;\n    margin-right: 15px;\n  }\n  .address-type{\n    background: #f4eded;\n    padding: 4px 8px;\n    border-radius: 6px;\n    font-weight: 400;\n  }\n  .payment-accordian-btn {\n    color: #000;\n    background: #fff;\n    font-weight: 600;\n    border-radius: 6px !important;\n    border:1px solid #D9D9D9 !important;\n    padding: 1.2rem !important;\n  }\n\n  .payment-accordian-item {\n    border-radius: 24px !important;\n  }\n\n  .payment-accordian-btn:not(.collapsed) {\n    color: #000;\n    background-color: #FFF;\n    box-shadow: inset 0 -1px 0 rgb(61 61 61 / 10%);\n    border-bottom-right-radius: 0px !important;\n    border-bottom-left-radius: 0px !important;\n    border-bottom: #636363 !important;\n  }\n  .payment-accordian-item .accordion-collapse{\n    border: 1px solid #D9D9D9;\n    border-top: none;\n  }\n  ul.catitemList li{\n    margin-bottom: 5px;\n    border-bottom: none !important;\n  }\n  \n  .whats-app {\n    position: fixed !important;\n    width: 50px !important;\n    height: 50px !important;\n    bottom: 40px !important;\n    right: 20px !important;\n    background-color: #25d366 !important;\n    color: #FFF !important;\n    border-radius: 50px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    font-size: 30px !important;\n    box-shadow: 2px 2px 3px #999 !important;\n    z-index: 100 !important;\n} \n\n.up-arrow {\n  position: fixed !important;\n  width: 45px !important;\n  height: 45px !important;\n  bottom: 100px !important;\n  right: 23px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  z-index: 100 !important;\n}\n\n.my-float {\n    margin: 0 !important;\n}\n/* .accordion-item {\n    background-color: #fff;\n    border: none;\n    box-shadow: 0 4px 16px 0 rgba(39, 49, 68, .04);\n    margin-bottom: 24px;\n    border-radius: 4px !important;\n    border: 1px solid #cfcfcf !important;\n}\n.accordion-button:not(.collapsed) {\n    color: #000;\n    background-color: #FFF;\n    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);\n    border-bottom-left-radius: 0px !important;\n    border-bottom-right-radius: 0px !important;\n} */\n\n.search-results {\n  position: absolute;\n  background-color: white;\n  width: 100%;\n  max-height: 500px; /* Increased max height to allow more items */\n  overflow-y: auto; /* Make it scrollable */\n  border: 1px solid #ccc; /* Optional: Add a border */\n  z-index: 1000; /* Ensure it appears above other elements */\n  border-radius: 10px;\n  padding: 10px; /* Add some padding for better appearance */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add a shadow for better visual separation */\n}\n\n/* Custom scrollbar styles */\n.search-results::-webkit-scrollbar {\n  width: 12px; /* Increase the width of the scrollbar */\n}\n\n.search-results::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Background of the scrollbar track */\n  border-radius: 45px;\n}\n\n.search-results::-webkit-scrollbar-thumb {\n  background: #888; /* Color of the scrollbar thumb */\n  border-radius: 10px;\n}\n\n.search-results::-webkit-scrollbar-thumb:hover {\n  background: #555; /* Color of the scrollbar thumb when hovered */\n}\n\n.search-item {\n  padding: 10px;\n  border-bottom: 1px solid #ccc; /* Optional: Add a bottom border to each item */\n}\n\n.search-item:last-child {\n  border-bottom: none; /* Remove border for the last item */\n}\n\n.search-item-content {\n  display: flex;\n  align-items: center;\n}\n\n.search-item-content img {\n  margin-right: 10px; /* Space between image and text */\n}\n\n.icon-flag img {\n  vertical-align: middle;\n}\n.btn-rounded13 {\n  padding: 5px 10px;\n  white-space: nowrap;\n  width: auto;\n  border-radius: 12px !important;\n}\n\n.app-logo {\n  height: 34.3833px;\n  object-fit: cover;\n}\n\n.box-with-plus {\n  border: 3px solid rgb(196, 192, 192);\n  width: 100px;\n  height: 110px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n@media (max-width: 768px) {\n    .d-flex {\n      flex-wrap: wrap;\n    }\n\n    .loading-spinner {\n    margin-top: 155px;\n    height: 200px; /* Adjust based on design */\n  }\n}\n\n@media (max-width: 480px) {\n  .loading-spinner {\n    margin-top: 130px; /* Adjust for smaller screens */\n    height: 150px; /* Further adjustments */\n  }\n}\n\n.loading-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 72px;\n}\n\n/* OTP Container */\n.otp-container {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n/* OTP Input Fields */\n.otp-input {\n  width: 45px;\n  height: 45px;\n  font-size: 1.5rem;\n  text-align: center;\n  border: 2px solid #ccc;\n  border-radius: 8px;\n  transition: border-color 0.3s ease-in-out;\n}\n\n.otp-input:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);\n  outline: none;\n}\n\n/* Media Query for Mobile Devices */\n@media (max-width: 576px) {\n  .otp-container {\n    gap: 5px;\n  }\n\n  .otp-input {\n    width: 35px;\n    height: 35px;\n    font-size: 1.2rem;\n  }\n}\n\n.marquee-container {\n  overflow: hidden;\n}\n\n.marquee-container-overdue {\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n  background-color: #fff3f3;\n  padding: 10px 0;\n  margin-top: 95px !important;\n  position: sticky !important;\n  top: 95px !important;\n  z-index: 100;\n}\n\n.marquee-container-overdue-mobile {\n  overflow: hidden;\n  white-space: nowrap;\n  width: 100%;\n  background-color: #fff3f3;\n  padding: 10px 0;\n  margin-top: 80px !important;\n  position: sticky !important;\n  top: 80px !important;\n  z-index: 100;\n}\n\n.marquee-container {\n  margin-top: 80px !important;\n  position: sticky !important;\n  top: 80px !important;\n  z-index: 100;\n}\n\n.marquee {\n  display: inline-block;\n  white-space: nowrap;\n  animation: marquee 15s linear infinite;\n}\n\n@keyframes marquee {\n  0%   { transform: translateX(100%); }\n  100% { transform: translateX(-100%); }\n}\n\n/* Media Query for Tablets */\n@media (max-width: 768px) {\n  .otp-input {\n    width: 40px;\n    height: 40px;\n    font-size: 1.3rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
